<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  <p>{{data.message}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" class="cancel-action" (click)="onCancel()">{{data.cancelText}}</button>
  <button mat-flat-button [color]="data.confirmColor || 'primary'" class="confirm-action" (click)="onConfirm()">
    {{data.confirmText}}
  </button>
</mat-dialog-actions>
